/* globals window */
import React, { Component } from 'react';

import $ from 'jquery';
import contextTypes from './ContextTypes';

// TODO: fix these files
/* eslint-disable no-underscore-dangle */

export default function scrollbarFactory(component) {
    return class ScrollbarFactory extends Component {
        static childContextTypes = contextTypes;

        constructor(props) {
            super(props);

            this._contextHelper = {};
            this._setScrollbarVisibility = this._setScrollbarVisibility.bind(this);
            this._setContextHelper = this._setContextHelper.bind(this);

            this.state = {
                isScrollbarVisible: true,
                setContextHelper: this._setContextHelper,
            };
        }

        getChildContext() {
            const delegateChanges = (methodName, newValue) => {
                const method = this._contextHelper[methodName];
                if (method) {
                    method(newValue);
                }
            };

            const setTableView = (tableView) => {
                this._tableView = tableView;
            };

            return {
                onResize() {
                    delegateChanges('onResize');
                },
                onTableChange() {
                    delegateChanges('onTableChange');
                },
                onTableScroll(newTablePosition) {
                    delegateChanges('onTableScroll', newTablePosition);
                },
                onScrollbarScroll(newScrollbarPosition) {
                    delegateChanges('onScrollbarScroll', newScrollbarPosition);
                },
                setTableView(tableView) {
                    setTableView(tableView);
                },
                setScrollbarVisibility: this._setScrollbarVisibility,
            };
        }

        componentDidMount() {
            window.addEventListener('resize', this._setScrollbarVisibility);
            $(window).on('verticalHeightChanged', this._setScrollbarVisibility);
            this._setScrollbarVisibility();
        }

        componentWillUnmount() {
            window.removeEventListener('resize', this._setScrollbarVisibility);
            $(window).off('verticalHeightChanged', this._setScrollbarVisibility);
        }

        _setContextHelper(methods) {
            this._contextHelper = { ...this._contextHelper, ...methods};
        }

        _setScrollbarVisibility() {
            const { isScrollbarVisible } = this.state;

            if (this._contextHelper) {
                const {
                    onTableChange = () => {},
                    onResize = () => {},
                } = this._contextHelper;

                onResize();
                onTableChange();

                if (this._tableView) {
                    const $table = $(this._tableView).find('table');

                    if ($table.closest('div').outerHeight(true) === 0) {
                        return;
                    }

                    const isNeedScrollbar =
            $table.outerHeight(true) > $table.closest('div').outerHeight(true);
                    if (isNeedScrollbar !== isScrollbarVisible) {
                        this.setState({ isScrollbarVisible: isNeedScrollbar });
                    }
                }
            }
        }

        render() {
            return React.createElement(component, {
                ...this.props,
                ...this.state,
            });
        }
    };
}
